import { cn } from "@humanex/ui/libs";
import * as React from "react";

export interface TextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  required?: boolean;
  labelClassName?: string;
  error?: string;
}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, labelClassName, required, error, ...props }, ref) => {
    return (
      <div>
        {label && (
          <div className={cn("text-responsive-base font-medium text-slate-400 mb-1", labelClassName)}>
            {label} {required && <span className="text-error-500">(*)</span>}
          </div>
        )}
        <textarea
          ref={ref}
          required={required}
          className={cn(
            "w-full rounded-lg border border-gray-200 bg-white px-4 py-2.5 text-sm font-normal text-ink",
            "placeholder:text-gray-500",
            "focus:ring-none focus:outline-none",
            "disabled:opacity-40",
            "resize-none min-h-[80px]",
            error && "border-error-500",
            className
          )}
          {...props}
        />
        {error && <p className="text-xs text-error-500 mt-1">{error}</p>}
      </div>
    );
  }
);

Textarea.displayName = "Textarea";
